import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useUserInfo } from '../../Authentication/hooks'
import NavigationComponent from '../navigationComponent'
import {
  customPostRequest,
  fetchUserSubscription,
  validateSimpleCategoryData,
  createNavigationHandlers,
  handleAsyncError
} from './utils/categoryUtils'
import userAvatar from '../../../assets/images/user-avatar.jpg'
import rightArrow from '../../../assets/images/46_Arrow_Right.jpg'
import reloadArrow from '../../../assets/images/reload-arrow2.jpg'
import '../../../assets/stylesheets/kategories.css'

const FriendsAndFamilyCategory = () => {
  const [memberName, setMemberName] = useState('')
  const [members, setMembers] = useState([])
  const [avatarStartIndex, setAvatarStartIndex] = useState(0)
  const { userId } = useUserInfo()
  const [message, setMessage] = useState('')
  const navigate = useNavigate()
  const [categoryCreated, setCategoryCreated] = useState(false)
  const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL
  const [showUpgradeLink, setShowUpgradeLink] = useState(false)

  const { handleHomeClick, handleUploadClick, handleSubscribeClick } =
    createNavigationHandlers(navigate)

  const avatars = new Array(10).fill(userAvatar)

  const handleCreate = async () => {
    if (!userId) {
      setMessage('User not authenticated')
      setShowUpgradeLink(false)
      return
    }

    if (!memberName) {
      setMessage('Please enter member name')
      setShowUpgradeLink(false)
      return
    }

    try {
      const subscriptionData = await fetchUserSubscription(
        userId,
        API_GATEWAY_URL
      )
      if (!subscriptionData) {
        setMessage('Failed to fetch subscription data')
        setShowUpgradeLink(true)
        return
      }

      const { categoryCount, categoryLimit } = subscriptionData

      console.log('Subscription Data:', categoryCount + 1, categoryLimit)
      if (categoryCount >= categoryLimit) {
        setMessage('You have reached your category limit.')
        setShowUpgradeLink(true)
        return
      }
    } catch (error) {
      const errorMessage = handleAsyncError(error, 'fetching category count')
      setMessage(`Failed to fetch category count: ${errorMessage}`)
      setShowUpgradeLink(true)
      return
    }

    const categoryData = {
      userId: userId,
      name: memberName,
      type: 'people',
      subType: 'friends_family'
    }

    if (!validateSimpleCategoryData(categoryData, setMessage)) {
      return
    }

    try {
      const apiURL = `${process.env.REACT_APP_API_GATEWAY_URL}/k1/users/${userId}/categories`
      const responseData = await customPostRequest(apiURL, categoryData)

      if (responseData.error) {
        throw new Error(responseData.error)
      }

      setMembers(prev => [...prev, memberName])
      setMemberName('')
      setMessage('Category created successfully!')
      setCategoryCreated(true)
    } catch (error) {
      const errorMessage = handleAsyncError(error, 'creating category')
      setMessage(`Failed to create category: ${errorMessage}`)
    }
  }

  const handleAddFriendOrFamily = () => {
    handleCreate()
  }

  const handleShowMoreAvatars = () => {
    if (avatarStartIndex + 4 < avatars.length) {
      setAvatarStartIndex(prev => prev + 4)
    } else {
      setAvatarStartIndex(0)
    }
  }

  const isAtEnd = avatarStartIndex + 4 >= avatars.length

  return (
    <div className="friends-family-category">
      <NavigationComponent handleHomeClick={handleHomeClick} />
      <h2 className="category-header">Friends & Family</h2>
      {message && <p className="message">{message}</p>}
      {showUpgradeLink && (
        <p>
          Please{' '}
          <span className="link-like" onClick={handleSubscribeClick}>
            upgrade
          </span>{' '}
          your plan.
        </p>
      )}
      {message === 'Category created successfully!' && (
        <p>
          <Link to="/gallery">Click here</Link> to return to the main gallery.
        </p>
      )}
      <input
        type="text"
        placeholder="Member Name"
        value={memberName}
        onChange={e => setMemberName(e.target.value)}
        className="input-field"
      />
      <div className="avatars-and-arrow">
        <div className="members-icons">
          {avatars
            .slice(avatarStartIndex, avatarStartIndex + 4)
            .map((avatar, index) => (
              <div key={index} className="member-icon">
                <div className="icon">
                  <img
                    src={avatar}
                    alt={`User ${index + avatarStartIndex + 1}`}
                  />
                </div>
                <span className="icon-name">
                  Name {index + avatarStartIndex + 1}
                </span>
              </div>
            ))}
        </div>
        <div className="member-icon arrow-icon" onClick={handleShowMoreAvatars}>
          <img
            src={isAtEnd ? reloadArrow : rightArrow}
            alt={isAtEnd ? 'Reload' : 'Next'}
            className="icon-image"
          />
        </div>
      </div>

      <div className="button-group">
        <button onClick={handleCreate} className="create-button">
          Create
        </button>
        <button
          onClick={() => {
            handleAddFriendOrFamily()
            setMemberName('')
          }}
          className="add-button"
        >
          +Add
        </button>
      </div>

      {categoryCreated && (
        <div className="list_and_upload">
          <ul>
            {members.map((member, index) => (
              <li className="added-list" key={index}>
                {member}
              </li>
            ))}
          </ul>
          <button className="upload-button-list" onClick={handleUploadClick}>
            Upload Photos
          </button>
        </div>
      )}
    </div>
  )
}

export default FriendsAndFamilyCategory
